import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { allAccountsGroupedByProviderAndOrgSelector } from "./allAccountsGroupedByProviderAndOrgSelector";
import { accountSelectionOptionsCombiner } from "../../combiners/accountSelectionOptionsCombiner";

export const allAccountsSelectOptionsSelector = createDraftSafeSelector(
  [allAccountsGroupedByProviderAndOrgSelector],
  accountSelectionOptionsCombiner,
);
